import {
  IMessageView,
  MessageViewEvent,
} from '../shared/components/message-view/message-view.component';

export const SignupSuccess = (email: string): IMessageView => {
  return {
    state: 'success',
    title: 'Please verify your Email ID',
    icon: 'person-mail',
    items: [
      {
        type: 'EMAIL',
        className: 'title text-14',
        email,
      },
      {
        type: 'TEXT',
        className: 'text-14',
        text: 'Check your inbox or spam folder for a link to verify your account and get started.',
      },
      {
        type: 'TEXT',
        className: 'sa-mv-footer',
        inlineItems: [
          {
            type: 'TEXT',
            className: 'text-14',
            text: `Didn't receive an email?`,
          },
          {
            type: 'LINK',
            className: 'text-14',
            link: {
              text: 'Resend Link',
              url: 'Resend Link',
              event: MessageViewEvent.RESEND,
            },
          },
        ],
      },
    ],
  };
};
export const SignupEmailVerificationFailure = (
  email: string,
  conf?: { message: string }
): IMessageView => {
  return {
    state: 'failure',
    title: conf?.message ? conf.message : 'Failed to send verification email',
    icon: 'person-mail',
    items: [
      {
        type: 'TEXT',
        text: 'Retry after sometime',
      },
      {
        type: 'EMAIL',
        email,
      },
      {
        type: 'LINK',
        link: {
          icon: 'send',
          text: 'Resend Link',
          url: 'Resend Link',
          event: MessageViewEvent.RESEND,
        },
      },
    ],
  };
};
export const SignupFailure = (
  email: string = '',
  conf?: { link: string; message?: string }
): IMessageView => {
  return {
    state: 'failure',
    title: conf?.message ? conf.message : 'Oops! Signup service is down',
    icon: 'error-circle',
    link: {
      icon: 'refresh',
      text: 'Refresh Page',
      url: conf?.link || '',
      event: MessageViewEvent.REFRESH,
    },
    items: [
      {
        type: 'TEXT',
        text: 'Please try after some time.',
      },
      {
        type: 'EMAIL',
        email,
      },
      {
        type: 'LINK',
        link: {
          icon: 'refresh',
          text: 'Refresh Page',
          url: conf?.link || '',
          event: MessageViewEvent.REFRESH,
        },
      },
    ],
  };
};
export const verifyEmailExpired = (): IMessageView => {
  return {
    state: 'failure',
    title: 'Email verification link expired',
    icon: 'error-circle',
    items: [
      {
        type: 'TEXT',
        text: 'Please click on resend link for new verification email',
      },
      {
        type: 'LINK',
        link: {
          icon: 'send',
          text: 'Resend Link',
          url: 'Resend Link',
          event: MessageViewEvent.RESEND,
        },
      },
    ],
  };
};
export const verifyPageFailure = (): IMessageView => {
  return {
    state: 'failure',
    title: 'Issue with verification link',
    icon: 'error-circle',
    items: [
      {
        type: 'TEXT',
        text: 'Something went wrong please try again',
      },
      {
        type: 'LINK',
        link: {
          icon: 'send',
          text: 'Resend Link',
          url: 'Resend Link',
          event: MessageViewEvent.RESEND,
        },
      },
    ],
  };
};
export const emailDoesNotExists = (): IMessageView => {
  return {
    state: 'failure',
    title: 'Email not found',
    icon: 'error-circle',
    items: [
      {
        type: 'TEXT',
        text: 'The email does not exists',
      },
    ],
  };
};
export const linkExpiry = (): IMessageView => {
  return {
    state: 'failure',
    title: 'Password Reset Link Expired',
    icon: 'error-circle',
    items: [
      {
        type: 'TEXT',
        text: 'Click "Resend Link" to request a new password reset email.',
      },
      {
        type: 'LINK',
        link: {
          icon: 'send',
          text: 'Resend Link',
          url: 'Resend Link',
          event: MessageViewEvent.RESEND,
        },
      },
    ],
  };
};
export const forgotPasswordSuccess = (email: string): IMessageView => {
  return {
    state: 'success',
    title: 'Password reset link sent',
    // text: 'Check your inbox or spam folder for a link to set new password.',
    icon: 'checkmark',
    items: [
      {
        type: 'EMAIL',
        email: email,
      },
      {
        type: 'TEXT',
        text: 'Check your inbox or spam folder for a link to set new password.',
      },
    ],
  };
};

export const resetSuccess = (email: string): IMessageView => {
  return {
    state: 'success',
    title: 'Your password has been reset',
    icon: 'checkmark',
    items: [
      {
        type: 'TEXT',
        inlineItems: [
          {
            type: 'TEXT',
            text: 'Now access your Saras account linked with',
          },
          {
            type: 'EMAIL',
            email,
          },
        ],
      },
      {
        type: 'BUTTON',
        text: 'Return to Login',
      },
    ],
  };
};
export const workEmailNotVerified = (email: string): IMessageView => {
  return {
    state: 'failure',
    title:
      'Your email is not verified yet. Verify your email first to set up a password.',
    icon: 'error-circle',
    items: [
      {
        type: 'EMAIL',
        className: 'title text-14',
        email,
      },
      {
        type: 'TEXT',
        className: 'sa-mv-footer',
        inlineItems: [
          {
            type: 'LINK',
            className: 'text-14',
            link: {
              icon: 'send',
              text: 'Send verification link',
              url: 'Resend Link',
              event: MessageViewEvent.RESEND,
            },
          },
        ],
      },
    ],
  };
};
/* messageview for mfa link expiry */
export const mfaLinkExpiry: IMessageView = {
  state: 'failure',
  title: 'MFA link expired',
  icon: 'error-circle',
  items: [
    {
      type: 'TEXT',
      text: 'Please contact support to un enroll your MFA.',
    },
  ],
};
/* messageview for users who are not currently enrolled with MFA */
export const mfaNotEnrolled: IMessageView = {
  state: 'failure',
  title: 'MFA not enrolled',
  icon: 'error-circle',
  items: [
    {
      type: 'TEXT',
      text: 'Your account is not enrolled with MFA.',
    },
    {
      type: 'TEXT',
      text: 'You can login with your email and password.',
    },
    {
      type: 'BUTTON',
      text: 'Login',
    },
  ],
};
export const mfaDisabledSuccess: IMessageView = {
  state: 'success',
  title: 'MFA disabled successfully',
  icon: 'checkCircleOutlined',
  items: [
    {
      type: 'TEXT',
      text: "You'll be automatically logged out from all active sessions.",
    },
    {
      type: 'TEXT',
      text: 'Please log in again to apply the changes',
    },
    {
      type: 'BUTTON',
      text: 'Login to Confirm Changes',
    },
  ],
};

export const defaultMessageViewFailure: IMessageView = {
  state: 'failure',
  title: 'Something went wrong',
  icon: 'error-circle',
  items: [
    {
      type: 'TEXT',
      text: 'Please try again after some time.',
    },
    {
      type: 'TEXT',
      text: 'If the error persists, please contanct support.',
    },
  ],
};
